import 'styles/application/modals/_nicotine-strength-details-modal.scss';

import React, { Fragment } from 'react';

import { TranslatedMessage } from 'common/components/Intl';
import Modal from 'common/components/modals/Modal';

export default class NicotineStrengthDetailsModal extends React.Component {
  render() {
    const { isOpen, toggleModal } = this.props;

    return (
      <Fragment>
        <span>
          <a
            onClick={() => toggleModal(true)}
            id={'NicotineStrengthModalTrigger'}
            className="nicotine-strength__link bold"
          >
            <TranslatedMessage
              id={'cart.nicotine_strength_details_modal.details'}
            />
          </a>.
        </span>
        <Modal isOpen={isOpen} onRequestClose={() => toggleModal(false)}>
          <div>
            <h1 className="nicotine-strength__title text--large flat-blue">
              Your experience, your choice.
            </h1>
            <p className="text">
              <TranslatedMessage
                id={'cart.nicotine_strength_details_modal.text'}
              />
            </p>
          </div>
        </Modal>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/components/NicotineStrengthDetailsModal.js